import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { RoutesService } from 'src/app/buses/_services/routes.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { GatesService } from 'src/app/school-management/_services/gates.service';
import { GradeService } from 'src/app/school-management/_services/grades.service';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { StudentService } from 'src/app/user-management/_services/student.service';
import { ControlDeletionService } from 'src/app/_services/control-deletion.service';
import { ControlQrService } from 'src/app/_services/control-qr.service';
import { GlobalService } from 'src/app/_services/global.service';
import { MessagesControlService } from 'src/app/_services/messages-control.service';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { UserService } from 'src/app/_services/user.service';

declare var $: any;
@Component({
  selector: 'app-qr-revamp',
  templateUrl: './qr-revamp.component.html',
  styleUrls: ['./qr-revamp.component.scss']
})
export class QrRevampComponent implements OnInit, OnDestroy, AfterViewInit {
  currLang;
  listType;
  selectedUsers = [];
  selectedIds = [];
  sub$ = new Subscription;
  languages;
  selectedLang = 'English';
  cardSizes;
  allGrades = [];
  selectedSize = '1';
  selectGradesFlag = false;
  selectedGrade;
  selectedOption = 'grade'
  toggleView;
  noGradesSelected: boolean = false;
  toggleStudentInfo = false;

  constructor(
    private routeService: RoutesService,
    private dataService: DataService,
    private userService: UserService,
    private controlDeletion: ControlDeletionService,
    private controlMessaging: MessagesControlService,
    private studentService: StudentService,
    private gatesService: GatesService,
    private gradesServie: GradeService,
    private snackBar: SnackbarService,
    private errorMsgService: ErrorMsgService,
    private translate: TranslateService,
    private globalService: GlobalService,
    private qrControl: ControlQrService,
  ) { }

  ngOnInit(): void {
    $(document).on('hidden.bs.modal', '#qrRevamp', () => {
      this.closeModalHandler();
    })

    $(document).on('shown.bs.modal', '#qrRevamp', () => {
      setTimeout(() => {
        this.selectOption('grade');
      }, 50);

      this.initOptions();
      if (this.toggleView == 'show-select') {
        this.selectedGrade = [this.allGrades[0].value];
      }
      else {
        this.selectedGrade = [];
      }
    })


    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    this.sub$ = this.qrControl.getQrRevampObj().subscribe(res => {
      this.listType = res['type'];
      this.selectedUsers = res['selected'];
      // this.toggleView = this.selectedUsers.length == 0 ? "show-select" :"show-dropdown";
      this.setToggleView();
      if (!!this.selectedUsers) {
        this.selectedIds = this.selectedUsers.map(user => user.id);
      }
    })

    this.dataService.getAllGrades().subscribe(res => {
      this.allGrades = res?.map(grade => ({
        value: grade.id,
        label: grade.name
      }));
      // this.selectedGrade = this.allGrades[0].value;
      // to preselect the first grade in case of multi select
      if(this.allGrades.length > 0){
        this.selectedGrade = [this.allGrades[0]?.value];
      }
    })
  }

  ngAfterViewInit(): void {
    // this.selectOption('grade');
  }

  initOptions() {
    this.languages = [
      { value: 'English', label: this.translate.instant('qr-revamp.print-options.english') },
      { value: 'Arabic', label: this.translate.instant('qr-revamp.print-options.arabic') }
    ]

    // each column prints two cards, so the label is twice the column_size value
    this.cardSizes = [
      { value: '1', label: this.translate.instant('qr-revamp.print-options.two-card') },
      { value: '2', label: this.translate.instant('qr-revamp.print-options.four-card') },
      { value: '3', label: this.translate.instant('qr-revamp.print-options.six-card') },
      { value: '4', label: this.translate.instant('qr-revamp.print-options.eight-card') },
      { value: '5', label: this.translate.instant('qr-revamp.print-options.ten-card') },
    ]
  }

  setToggleView() {
    const noUserSelectedMapping = {
      assistants: "show-alert",
      default: "show-select"
    };

    const noSelectionView = this.listType === "assistants" ? noUserSelectedMapping.assistants : noUserSelectedMapping.default;
    this.toggleView = this.selectedUsers.length === 0 ? noSelectionView : "show-dropdown";
  }

  onSelectionChange() {
    if (this.selectGradesFlag && this.selectedGrade.length > 0) {
      this.noGradesSelected = false;
    }
  }
  generatePdf() {
    const userMapping = {
      students: { user: 'student', urlType: 'students' },
      parents: { user: 'parent', urlType: 'parents' },
      assistants: { user: 'helper', urlType: 'parents' }
    };
    if (this.selectGradesFlag && this.selectedGrade.length == 0) {
      this.noGradesSelected = true;
    }
    else {
      let user = '';
      let body: any = {};
      user = userMapping[this.listType].user;
      body = {
        "role_name": "school_admin",
        "language": this.selectedLang == "English" ? "EN" : "AR",
        "format": "A4-L",
        "column_size": this.selectedSize,
        "include_students": this.toggleStudentInfo,
        "filter": {
          "role": [`${user}`]
        },
      }

      if (this.selectedGrade.length > 0) {
        body.filter.grade_id = this.selectedGrade;
      }

      switch (this.listType) {
        case 'students':
          body.students = this.selectedIds;
          delete body.filter.role
          delete body.include_students
          break;
        case 'parents':
          body.parents = this.selectedIds;
          break;
        case 'assistants':
          body.parents = this.selectedIds;
          body.role_type = 'helper'
          body.include_students = false;
          break;
        default:
          break;
      }
      this.globalService.setPrintQrAlert('preparing');
      this.closeModalHandler();
      this.qrControl.printQr(body, userMapping[this.listType].urlType).subscribe(res => {
      })
    }
  }

  selectOption(type) {
    this.selectedOption = type;
    $('div.selected-option').removeClass('selected-option');
    $(`#${type}-option`).addClass('selected-option');
  }

  resetSelectGroup() {
    this.selectedOption = 'grade';
    $('div.selected-option').removeClass('selected-option');
  }

  next() {
    switch (this.selectedOption) {
      case 'grade':
        this.selectGradesFlag = true;
        this.toggleView = 'show-dropdown'
        break;
      case 'user':
        this.toggleView = 'show-alert'
        break;
    }

  }

  alert() {

  }

  closeModalHandler() {
    this.selectGradesFlag = false;
    this.noGradesSelected = false;
    // this.selectedGrade = [this.allGrades[0].value];
    this.selectedLang = 'English';
    this.selectedSize = '1';
    this.selectOption('grade');
    this.toggleStudentInfo = false;
    $("#qrRevamp").modal("hide");
  }

  ngOnDestroy(): void {
    this.sub$.unsubscribe();
  }

}
